module.exports = __webpack_public_path__ + "static/media/christian.b5556b2e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/information/crew/christian.jpg
// module id = 616
// module chunks = 0